module.exports = __webpack_public_path__ + "static/media/bbehavior.26e5ae7c.svg";